import { render, staticRenderFns } from "./LotMortalityPage.vue?vue&type=template&id=a082f768&scoped=true"
import script from "./LotMortalityPage.vue?vue&type=script&lang=js"
export * from "./LotMortalityPage.vue?vue&type=script&lang=js"
import style0 from "./LotMortalityPage.vue?vue&type=style&index=0&id=a082f768&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a082f768",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a082f768')) {
      api.createRecord('a082f768', component.options)
    } else {
      api.reload('a082f768', component.options)
    }
    module.hot.accept("./LotMortalityPage.vue?vue&type=template&id=a082f768&scoped=true", function () {
      api.rerender('a082f768', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/plantNursery/lots/LotMortalityPage.vue"
export default component.exports